<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-xl-6 offset-xl-3">
          <card>
            <template slot="header">
              <h4 class="card-title">Pagina non trovata</h4>
            </template>
            <p>La pagina che stai cercando non esiste.</p>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Card from 'src/components/UIComponents/Cards/Card.vue'
  export default {
    components: {
      Card
    }
  }

</script>



// WEBPACK FOOTER //
// src/components/GeneralViews/NotFoundPage.vue